import React from "react";
import { motion } from "framer-motion";
import {
  Wifi,
  Car,
  Waves,
  PawPrint,
  Home,
  Plane,
  Martini,
  Snowflake,
  Flame,
  Sparkles,
  FileText,
  Cigarette,
  DoorOpen,
  UtensilsCrossed,
  Dumbbell,
  ShoppingCart,
  Wind,
  Bath,
  Coffee as Tea,
} from "lucide-react";

const amenities = {
  "Бесплатный Wi-Fi": Wifi,
  "Бесплатная парковка": Car,
  Парковка: Car,
  "Кофеварка / чайник во всех номерах": Tea,
  "Пляж (первая линия)": Waves,
  "Частная пляжная зона": Waves,
  "Можно с питомцами": PawPrint,
  "Семейные номера": Home,
  "Трансфер от/до аэропорта": Plane,
  Бар: Martini,
  Отопление: Snowflake,
  "1 бассейн": Flame,
  "Принадлежности для барбекю": Sparkles,
  "2 бассейна": Flame,
  "Круглосуточная стойка регистрации": FileText,
  "Места для курения": Cigarette,
  "Катание на лыжах": DoorOpen,
  Ресторан: UtensilsCrossed,
  "Спа и оздоровительный центр": Dumbbell,
  "Доставка еды и напитков в номер": ShoppingCart,
  Терраса: Wind,
  "Фитнес-центр": Dumbbell,
  "Баня/сауна": Bath,
  "Чан с подогревом": Tea,
};

const DefaultIcon = () => <span className="w-6 h-6" />;

export default function AmenitiesSection({
  popular_services,
  accentColor = "#14b8a6",
  textColor = "#000",
}) {
  return (
    // pt-6 pb-20 вместо py-10
    <section className="pt-6 pb-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span
            className="inline-block px-4 py-1.5 text-sm font-medium rounded-full mb-4"
            style={{ backgroundColor: `${accentColor}20`, color: accentColor }}
          >
            Преимущества
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">
            Всё для вашего комфорта
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {popular_services.map((name, idx) => {
            const Icon = amenities?.[name] || DefaultIcon;
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                // 0.02 вместо 0.05
                transition={{ delay: idx * 0.02 }}
                className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl hover:bg-teal-50 transition-colors"
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = `${accentColor}15`)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "")
                }
              >
                <div
                  className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{
                    backgroundColor: `${accentColor}20`,
                    color: textColor,
                  }}
                >
                  <Icon className="w-6 h-6 text-teal-600" />
                </div>
                <span className="font-medium text-gray-900">{name}</span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
